<template>
  <div>
    <counters />
    <b-card no-body>
      <b-card-body>
        <filter-card :get-data-list="getDataList" />
      </b-card-body>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="dataList"
        striped
      >
        <template #cell(ddate)="data">
          {{ moment(data.item.ddate).format('DD.MM.YYYY') }}
        </template>
        <template #cell(donation_group)="data">
          <b-link @click="openModal(data.item)">
            <div
              :class="data.item.is_transferred? 'text-line-through text-body' : ''"
              class="d-flex align-items-center justify-content-between"
            >
              <div>
                <div class="text-primary font-weight-bold">
                  {{ data.item.donation_group }}
                </div>
                <div class="text-muted font-small-2">
                  {{ data.item.notes }}
                </div>
                <div>
                  <b-badge :variant="data.item.id_donation_types === '1'? 'light-warning' : 'light-danger'">
                    {{ data.item.donation_type }}
                  </b-badge>
                </div>
              </div>
              <div>
                <FeatherIcon
                  v-b-tooltip.hover.left="data.item.account_type"
                  icon="FlagIcon"
                  :class="data.item.id_account_types === '1'? 'text-success' : 'text-danger'"
                />
              </div>
            </div>
            <div
              v-if="data.item.is_transferred"
              class="font-weight-bold font-small-2 text-danger"
            >
              Banka hesabına transfer edildi.
            </div>
          </b-link>
        </template>
        <template #cell(bank_account)="data">
          <div v-if="data.item.bank_account">
            <div class="font-weight-bold">
              Banka
            </div>
            <div class="font-small-3 text-primary">
              {{ data.item.bank_account }}
            </div>
          </div>
          <div v-if="data.item.safe">
            <div class="font-weight-bold">
              Kasa
            </div>
            <div class="font-small-3 text-danger">
              {{ data.item.safe }}
            </div>
          </div>
        </template>
        <template #cell(amount)="data">
          <div
            :class="data.item.is_transferred? 'text-line-through' : ''"
          >
            <div
              v-if="data.item.is_income"
              class="text-success font-weight-bold"
            >
              +{{ data.item.amount | toCurrency }} {{ data.item.currency }}
            </div>
            <div
              v-if="data.item.is_expense"
              class="text-danger font-weight-bold"
            >
              {{ data.item.amount | toCurrency }} {{ data.item.currency }}
            </div>
          </div>
        </template>
        <template #cell(control)="data">
          <div class="text-right">
            <list-buttons
              v-if="!data.item.is_transferred"
              :edit-action="getEditAction(data.item)"
              :delete-action="removeData"
              :data-id="data.item.id"
            />
          </div>
        </template>
      </b-table>
      <b-card-footer>
        <b-pagination
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
      <view-modal />
    </b-card>
  </div>
</template>
<script>
import {
  BCard, BCardBody, BBadge, BTable, BPagination, BCardFooter, BLink, VBTooltip,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListButtons.vue'
import FilterCard from '@/views/Admin/Account_activities/Components/FilterCard.vue'
import ViewModal from '@/views/Admin/Account_activities/Components/ViewModal.vue'
import Counters from '@/views/Admin/Account_activities/Components/Counters.vue'
import toastMixin from '@/libs/toast'

export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BBadge,
    BTable,
    BPagination,
    BCardFooter,
    BLink,
    ListButtons,
    FilterCard,
    ViewModal,
    Counters,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [toastMixin],
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'ddate',
          label: 'TARİH',
          thClass: 'width-100 text-nowrap',
          tdClass: 'width-100 text-nowrap',
        },
        {
          key: 'donation_group',
          label: 'Tanım',
        },
        {
          key: 'bank_account',
          label: 'HESAP',
          thClass: 'width-200 text-nowrap text-left',
          tdClass: 'width-200 text-nowrap text-left',
        },
        {
          key: 'amount',
          label: 'TUTAR',
          thClass: 'width-50 text-nowrap text-right',
          tdClass: 'width-50 text-nowrap text-right',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-50 text-nowrap',
          tdClass: 'width-50 text-nowrap',
        },
      ],
      dataQuery: {
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    filterParams() {
      return this.$store.getters['accountActivities/filterParams']
    },
    dataList() {
      return this.$store.getters['accountActivities/dataList']
    },
    dataCounts() {
      return this.$store.getters['accountActivities/dataCounts']
    },
    saveData() {
      return this.$store.getters['accountActivities/dataSaveStatus']
    },
    dataItem() {
      return this.$store.getters['accountActivities/dataItem']
    },
    dataModal() {
      return this.$store.getters['accountActivities/dataModal']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'removeSuccess' })
      } else if (val.status === false) {
        this.showToast({ template: 'removeError' })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
    this.getCounters()
  },
  methods: {
    getEditAction(item) {
      // eslint-disable-next-line no-unused-vars
      let result = ''
      if (item.is_income) {
        result = `${this.$route.path}/incomes/edit/${item.id}`
      } else {
        result = `${this.$route.path}/expenses/edit/${item.id}`
      }
      return result
    },
    openModal(data) {
      this.dataModal.status = true
      this.dataModal.dataItem = data
      this.dataItem.donor_name = data.donor_name
      this.dataItem.donor_phone = data.donor_phone
      this.dataItem.donor_address = data.donor_address
    },
    getCounters() {
      this.$store.dispatch('accountActivities/getCounters')
    },
    getDataList() {
      const filterData = {}
      if (this.filterParams.keyword) {
        this.dataQuery.or_like = {
          'account_activities.notes': this.filterParams.keyword,
        }
      } else {
        delete this.dataQuery.or_like
      }
      if (this.filterParams.id_donation_types) {
        filterData.id_donation_types = this.filterParams.id_donation_types
      }
      if (this.filterParams.id_types) {
        filterData.id_types = this.filterParams.id_types
      }
      if (this.filterParams.id_donation_groups) {
        filterData.id_donation_groups = this.filterParams.id_donation_groups
      }
      if (this.filterParams.id_bank_accounts) {
        filterData.id_bank_accounts = this.filterParams.id_bank_accounts
      }
      if (this.filterParams.id_safes) {
        filterData.id_safes = this.filterParams.id_safes
      }
      if (this.filterParams.sdate) {
        filterData.sdate = this.filterParams.sdate
      }
      if (this.filterParams.edate) {
        filterData.edate = this.filterParams.edate
      }
      if (this.filterParams.min_amount) {
        filterData.min_amount = this.filterParams.min_amount
      }
      if (this.filterParams.max_amount) {
        filterData.max_amount = this.filterParams.max_amount
      }
      if (this.filterParams.receipt_status) {
        filterData.receipt_status = this.filterParams.receipt_status
      }
      if (filterData) {
        this.dataQuery.filter = filterData
      }
      if (this.filterParams.is_transferred) {
        this.dataQuery.where = {
          'account_activities.is_transferred': null,
        }
      } else {
        delete this.dataQuery.where
      }
      this.$store.dispatch('accountActivities/getCustomList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('accountActivities/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>
<style scoped>
.text-line-through{
  text-decoration: line-through !important;
}
.text-line-through div{
  color: var(--gray) !important;
}
</style>
